import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Relative dependencies.
import { SCWShardsComponent } from './shards.component';
// Resolvers.
import { ShardsResolver } from './shards.resolver';

const routes: Routes = [
  {
    path: 'shards',
    component: SCWShardsComponent,
    resolve: {
      shards: ShardsResolver,
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class ShardsRoutingModule { }
